import React, { useState, useRef } from "react";
import "./ParametresSite.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FaEye, FaEyeSlash, FaPen, FaRedo } from "react-icons/fa";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { updateAdmin } from "Redux/Actions/adminActions";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import {
  findItemInEditManagementVisibility,
  findManagementContentByLabel,
} from "Services/functions";
import Legendes from "./Legendes";
import { Toast } from "primereact/toast";
import axios from "axios";
import { useEffect } from "react";

/**
 * Permet d'afficher la page de paramétrage du site
 * Page accessible uniquement pour les administrateurs
 */
const ParametresSite = (props) => {
  const successUpdate = useRef(null);
  const [itemsVisibleModified, setItemsVisibleModified] = useState([]);

  // Liste de tous les items éditable, avec leur nom, la valeur par défaut et le titre de la ligne
  const itemLabelToShow = [
    { name: "accueilTitle", default: "Accueil", title: "Titre pour l'accueil" },
    {
      name: "evenementsTitle",
      default: "Événements",
      title: "Titre pour les événements",
    },
    {
      name: "actusTitle",
      default: "Actus",
      title: "Titre pour les actualités",
    },
    {
      name: "offresTitle",
      default: "Offres d'emploi",
      title: "Titre pour les offres d'emploi",
    },
    {
      name: "groupesTitle",
      default: "Groupes",
      title: "Titre pour les groupes",
    },
    {
      name: "conseilsTitle",
      default: "Conseils",
      title: "Titre pour l'annuaire",
    },
    {
      name: "annuaireTitle",
      default: "Annuaire",
      title: "Titre pour les conseils",
    },
  ];

  // la variable renommage sert à afficher ou non l'input de renommage
  // la variable Title permet de stoker la valeur du grand module et de l'afficher
  // la variable error permet d'afficher une erreur si l'utilisateur veut soumettre un nom de module vide
  const [renommageValues, setRenommageValues] = useState({
    accueilTitle: false,
    evenementsTitle: false,
    actusTitle: false,
    offresTitle: false,
    groupesTitle: false,
    annuaireTitle: false,
    conseilsTitle: false,
  });
  const updateEditAdminObj = (e, objToFound) => {
    const objFoundWithLabel = props.admin.editManagement.find(
      (item) => item.label == objToFound
    );
    let objFindWithUnivConnected = {};
    if (objFoundWithLabel?.contentManagement.length > 0) {
      objFindWithUnivConnected = objFoundWithLabel.contentManagement.filter(
        (item) =>
          item.editedByUniversity?.id === props.auth.universityConnected.id
      );
    }
    let itemUpdate = {};
    itemUpdate.label = objToFound;
    itemUpdate.contentManagement = [];
    itemUpdate.id = objFoundWithLabel.id;
    let contentManagementObj = {};
    if (objFindWithUnivConnected.length > 0) {
      contentManagementObj = { ...objFindWithUnivConnected[0] };
      contentManagementObj.content = e;
    } else {
      contentManagementObj.content = e;
      contentManagementObj.editedByUniversity = props.auth.universityConnected;
    }
    itemUpdate.contentManagement.push(contentManagementObj);
    return itemUpdate;
  };
  const updateEditAdminBooleanObj = (objToFound) => {
    const objFoundWithLabel = props.admin.editManagementBoolean.find(
      (item) => item.label == objToFound
    );
    let objFindWithUnivConnected = {};
    if (objFoundWithLabel?.valueManagement.length > 0) {
      objFindWithUnivConnected = objFoundWithLabel.valueManagement.filter(
        (item) =>
          item.editedByUniversity?.name === props.auth.universityConnected.name
      );
    }
    let itemUpdate = {};
    itemUpdate.label = objToFound;
    itemUpdate.valueManagement = [];
    itemUpdate.id = objFoundWithLabel.id;
    let valueManagementObj = {};
    if (objFindWithUnivConnected.length > 0) {
      valueManagementObj = { ...objFindWithUnivConnected[0] };
      valueManagementObj.value = !objFindWithUnivConnected[0].value;
    } else {
      valueManagementObj.value = !objFoundWithLabel.valueManagement[0].value;
      valueManagementObj.editedByUniversity = props.auth.universityConnected;
    }
    itemUpdate.valueManagement.push(valueManagementObj);
    setItemsVisibleModified([...itemsVisibleModified, itemUpdate]);
    return itemUpdate;
  };
  //? Fonction permettant la réinitialisation des paramètres par défaut
  // Prend en argument le nom de l'item à éditer et la valeur par défaut à mettre
  const resetEditManagementItem = (EMitemLabel, defaultString) => {
    let newEditManagement = [...props.admin.editManagement];
    let newEditBoolean = [...props.admin.editManagementBoolean];

    newEditManagement.forEach((item) => {
      if (item.label === EMitemLabel) {
        item.contentManagement[0].content = defaultString;
      }
    });

    if (EMitemLabel === "conseilsTitle") {
      newEditBoolean.forEach((item) => {
        if (item.label === "visibleConseils") {
          item.valueManagement[0].value = true;
        }
      });
    }
    if (EMitemLabel === "annuaireTitle") {
      newEditBoolean.forEach((item) => {
        if (item.label.includes("visibleAnnuaire")) {
          item.valueManagement[0].value = true;
        }
      });
    }

    props.handleAdmin({
      editManagement: newEditManagement,
      editManagementBoolean: newEditBoolean,
    });
  };

  // Fonction qui, pour l'item donné en argument, remplace sa ligne par une zone de texte éditable pour pouvoir le modifier
  const renommage = (EMitemLabel) => {
    return (
      <div className="parametres_site__container__content__left__item small input">
        <div className="p-inputgroup">
          <InputText
            placeholder={"Nouveau titre"}
            value={
              findManagementContentByLabel(
                EMitemLabel,
                props.admin.editManagement,
                props.admin.editManagementNexus,
                props.auth.universityConnected.id
              ).content
            }
            name={EMitemLabel}
            onChange={(e) => {
              props.handleAdmin({
                editManagement: [
                  ...props.admin.editManagement.filter(
                    (item) => item.label !== EMitemLabel
                  ),
                  updateEditAdminObj(e.target.value, EMitemLabel),
                ],
              });
            }}
            autoFocus
          />
          <Button
            label="OK"
            onClick={() => {
              let newRenommage = { ...renommageValues };
              newRenommage[EMitemLabel] = !renommageValues[EMitemLabel];
              setRenommageValues(newRenommage);
              setItemsModified([
                ...itemsModified,
                props.admin.editManagement.find(
                  (item) => item.label == EMitemLabel
                ),
              ]);
            }}
          />
        </div>
      </div>
    );
  };

  const EyesIconTrue = (item) => {
    const value = Object.values(item)[0];

    return (
      <FaEye
        size={"2em"}
        onClick={() => {
          props.handleAdmin({
            editManagementBoolean: [
              ...props.admin.editManagementBoolean.filter(
                (item) => item.label !== value
              ),
              updateEditAdminBooleanObj(value),
            ],
          });
        }}
      />
    );
  };

  const EyesIconFalse = (item) => {
    const value = Object.values(item)[0];

    return (
      <FaEyeSlash
        size={"2em"}
        onClick={() => {
          props.handleAdmin({
            editManagementBoolean: [
              ...props.admin.editManagementBoolean.filter(
                (item) => item.label !== value
              ),
              updateEditAdminBooleanObj(value),
            ],
          });
        }}
      />
    );
  };

  const [itemsModified, setItemsModified] = useState([]);
  useEffect(() => {
    return setItemsModified([]);
  }, []);
  useEffect(() => {
    return setItemsVisibleModified([]);
  }, []);

  const putDataToApi = async () => {
    try {
      const response = await Promise.all([
        itemsModified.map((itemModified) => {
          axios.post(
            `${process.env.REACT_APP_BASE_URL_API}/editorial_management/${itemModified.id}/edit_content`,
            { content: itemModified.contentManagement[0].content },
            {
              headers: props.auth.token
                ? {
                    accept: "application/json",
                    "Content-Type": "application/json",

                    Authorization: `Bearer ${props.auth.token}`,
                  }
                : {
                    accept: "application/json",
                    "Content-Type": "application/json",
                  },
            }
          );
        }),
        itemsVisibleModified.map((itemVisibleModified) => {
          axios.post(
            `${process.env.REACT_APP_BASE_URL_API}/editorial_management_boolean/${itemVisibleModified.id}/edit_content`,
            { value: itemVisibleModified.valueManagement[0].value },
            {
              headers: props.auth.token
                ? {
                    accept: "application/json",
                    "Content-Type": "application/json",

                    Authorization: `Bearer ${props.auth.token}`,
                  }
                : {
                    accept: "application/json",
                    "Content-Type": "application/json",
                  },
            }
          );
        }),
      ]);
      response && showSuccess();
    } catch {
      successUpdate.current.show({
        severity: "error",
        summary: "Erreur",
        detail: "Une erreur est survenue",
        life: 5000,
      });
    }
  };
  //? Fonction pour appeler le Toast
  const showSuccess = () => {
    successUpdate.current.show({
      severity: "success",
      summary: "Mise à jour effectuée avec succès",
      detail: "Votre mise à jour a bien été prise en compte",
      life: 3000,
    });
  };

  const showSuccessRefresh = () => {
    successUpdate.current.show({
      severity: "success",
      summary: "Réinitialisation effectuée avec succès",
      detail: "Votre contenu a bien été réinitialisé",
    });
  };

  return (
    <div className="parametres_site">
      <Toast ref={successUpdate} />
      {props.auth.isConnected && (
        <div className="parametres_site__container">
          <div className="parametres_site__container__title">
            <h1 className="h1_trait_dessus">
              {props.items[props.activeIndex].label}
            </h1>
            <div className="parametres_site__container__title__filtre">
              {/* {findDate()} */}
            </div>
          </div>
          <div className="parametres_site__container__content">
            <div className="parametres_site__container__content__left">
              {/* Créé une ligne d'édition pour chaque item éditable.
              S'il s'agit de l'annuaire ou des conseil, ajoute l'option visible/invisible */}
              {itemLabelToShow.map((item, index) => {
                let gotEye = null;
                if (item.name === "conseilsTitle") gotEye = "visibleConseils";
                if (item.name === "annuaireTitle") gotEye = "visibleAnnuaire";

                return !renommageValues[item.name] ? (
                  <div
                    className="parametres_site__container__content__left__item"
                    key={index}
                  >
                    {item.title}
                    <div className="parametres_site__container__content__left__item__icons">
                      {gotEye ? (
                        findItemInEditManagementVisibility(
                          gotEye,
                          props.admin.editManagementBoolean
                        ) ? (
                          <EyesIconTrue item={gotEye} />
                        ) : (
                          <EyesIconFalse item={gotEye} />
                        )
                      ) : (
                        <></>
                      )}
                      <FaPen
                        size={"1.5em"}
                        onClick={() => {
                          let newRenommage = { ...renommageValues };
                          newRenommage[item.name] = !renommageValues[item.name];
                          setRenommageValues(newRenommage);
                        }}
                      />
                      <FaRedo
                        size={"1.5em"}
                        onClick={() => {
                          resetEditManagementItem(item.name, item.default);
                          setItemsModified([
                            ...itemsModified,
                            props.admin.editManagement.find(
                              (element) => element.label == item.name
                            ),
                          ]);
                          showSuccessRefresh();
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    {renommage(item.name)}
                    {/* {getError("Accueil")} */}
                  </>
                );
              })}

              <div className="parametres_site__container__content__left__item small">
                Visibilité de l&apos;annuaire étudiants
                <div className="parametres_site__container__content__left__item__icons">
                  {findItemInEditManagementVisibility(
                    "visibleAnnuaireEtudiant",
                    props.admin.editManagementBoolean
                  ) ? (
                    <EyesIconTrue item={"visibleAnnuaireEtudiant"} />
                  ) : (
                    <EyesIconFalse item={"visibleAnnuaireEtudiant"} />
                  )}
                </div>
              </div>
              <div className="parametres_site__container__content__left__item small">
                Visibilité de l&apos;annuaire Alumni
                <div className="parametres_site__container__content__left__item__icons">
                  {findItemInEditManagementVisibility(
                    "visibleAnnuaireAlumni",
                    props.admin.editManagementBoolean
                  ) ? (
                    <EyesIconTrue item={"visibleAnnuaireAlumni"} />
                  ) : (
                    <EyesIconFalse item={"visibleAnnuaireAlumni"} />
                  )}
                </div>
              </div>
              <div className="parametres_site__container__content__left__item small">
                Visibilité de l&apos;annuaire entreprises
                <div className="parametres_site__container__content__left__item__icons">
                  {findItemInEditManagementVisibility(
                    "visibleAnnuaireEntreprise",
                    props.admin.editManagementBoolean
                  ) ? (
                    <EyesIconTrue item={"visibleAnnuaireEntreprise"} />
                  ) : (
                    <EyesIconFalse item={"visibleAnnuaireEntreprise"} />
                  )}
                </div>
              </div>
              <BtnBleu
                btnTexte="Mettre à jour"
                btnAction={() => putDataToApi()}
              />
            </div>
            <div className="parametres_site__container__content__right">
              <Legendes />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

ParametresSite.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  checked: PropTypes.bool,
  setChecked: PropTypes.func,
  admin: PropTypes.object,
  handleAdmin: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  admin: state.admin,
});

const mapDispatchToProps = (dispatch) => ({
  handleAdmin: (value) => {
    dispatch(updateAdmin(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ParametresSite);

// const [errors, setErrors] = useState({
//   accueilTitle: false,
//   evenementsTitle: false,
//   actusTitle: false,
//   offresTitle: false,
//   groupesTitle: false,
//   annuaireTitle: false,
//   conseilsTitle: false,
// });
// const [errorAccueil, setErrorAccueil] = useState(false);
// const [errorEvenements, setErrorEvenements] = useState(false);
// const [errorActus, setErrorActus] = useState(false);
// const [errorOffres, setErrorOffres] = useState(false);
// const [errorGroupes, setErrorGroupes] = useState(false);
// const [errorAnnuaire, setErrorAnnuaire] = useState(false);
// const [errorConseils, setErrorConseils] = useState(false);

//? Fonction gérant les erreurs des inputs vides
// function changeError(item, value) {
//   switch (item) {
//     case "accueilTitle":
//       value === "" ? setErrorAccueil(true) : setErrorAccueil(false);
//       break;
//     case "evenementsTitle":
//       value === "" ? setErrorEvenements(true) : setErrorEvenements(false);
//       break;
//     case "actusTitle":
//       value === "" ? setErrorActus(true) : setErrorActus(false);
//       break;
//     case "offresTitle":
//       value === "" ? setErrorOffres(true) : setErrorOffres(false);
//       break;
//     case "groupesTitle":
//       value === "" ? setErrorGroupes(true) : setErrorGroupes(false);
//       break;
//     case "annuaireTitle":
//       value === "" ? setErrorAnnuaire(true) : setErrorAnnuaire(false);
//       break;
//     case "conseilsTitle":
//       value === "" ? setErrorConseils(true) : setErrorConseils(false);
//       break;
//     default:
//       break;
//   }
// }

// fonction permettant d'afficher l'erreur en dessous de l'input
// function getError(bool) {
//   return (
//     bool && (
//       <div className="parametres_site__container__content__left__item small error">
//         <p>Veuillez remplir ce champ</p>
//       </div>
//     )
//   );
// }

//? Composant qui permet de retourner la date de mise à jour de l'élément cliqué si il a déjà été modifié
// const findDate = () => {
//   const objFoundWithLabel = props.admin.editManagement.find(
//     (item) => item.label == openMenu
//   );
//   let objFindWithUnivConnected = {};
//   if (objFoundWithLabel?.contentManagement.length > 0) {
//     objFindWithUnivConnected = objFoundWithLabel.contentManagement.filter(
//       (item) =>
//         item.editedByUniversity?.id === props.auth.universityConnected.id
//     );
//   }
//   return Array.isArray(objFindWithUnivConnected) ? (
//     <>
//       <h6>
//         Dernière modification le&nbsp;
//         <strong>
//           {formatDateHourFrenchLocale(objFindWithUnivConnected[0].updatedAt)}
//         </strong>
//       </h6>
//       <img
//         src={API_LINK + props.auth.universityConnected.imageUrl}
//         alt={"Logo Université " + props.auth.universityConnected.name}
//         title={"Logo Université " + props.auth.universityConnected.name}
//       />
//     </>
//   ) : (
//     <h6>Elément jamais modifié</h6>
//   );
// };
